import React from 'react';
import { motion } from 'framer-motion';
import { FadeInWhenVisible, SectionHeader } from './SectionWrapper';
import { SKILLS } from '../data/portfolio';

function SkillDots({ level, max = 5 }) {
  return (
    <div className="flex gap-1 mb-3">
      {Array.from({ length: max }).map((_, i) => (
        <div
          key={i}
          className="w-1.5 h-1.5 rounded-full"
          style={{
            background: i < level ? 'var(--gold)' : undefined,
            backgroundColor: i < level ? 'var(--gold)' : '#2a3550',
          }}
        />
      ))}
    </div>
  );
}

function SkillCard({ skill, isDark, index }) {
  return (
    <FadeInWhenVisible delay={index * 0.07}>
      <motion.div
        whileHover={{ y: -6, scale: 1.02 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        className={`relative rounded-xl border p-5 h-full overflow-hidden group cursor-default card-hover-glow transition-all duration-300 ${
          isDark
            ? 'bg-navy-600 border-navy-300/50 hover:border-navy-300'
            : 'bg-white border-gray-200 hover:border-gray-300 shadow-sm'
        }`}
      >
        {/* Gold top accent line */}
        <div
          className="absolute top-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ background: 'linear-gradient(90deg, var(--gold), transparent)' }}
        />

        {/* Category tag */}
        <p className={`font-mono text-[10px] tracking-[0.15em] uppercase mb-2 ${isDark ? 'text-gold/70' : 'text-gold-muted/70'}`}>
          {skill.category}
        </p>

        {/* Skill level dots */}
        <SkillDots level={skill.level} />

        {/* Title */}
        <h3 className={`font-sans font-bold text-sm mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>
          {skill.title}
        </h3>

        {/* Items */}
        <div className="flex flex-wrap gap-1.5">
          {skill.items.map((item) => (
            <span
              key={item}
              className={`font-mono text-[11px] px-2 py-1 rounded border transition-all duration-200 group-hover:border-gold/25 ${
                isDark
                  ? 'text-gray-400 bg-navy-700/60 border-navy-400/50 group-hover:text-gray-200'
                  : 'text-gray-500 bg-gray-50 border-gray-200 group-hover:text-gray-700'
              }`}
            >
              {item}
            </span>
          ))}
        </div>
      </motion.div>
    </FadeInWhenVisible>
  );
}

export default function Skills({ isDark }) {
  return (
    <section
      id="skills"
      className={`py-24 ${isDark ? 'bg-navy-900' : 'bg-white'}`}
    >
      <div className="max-w-6xl mx-auto px-6">
        <SectionHeader tag="// 02. tech stack" heading="Skills &amp; Technologies" isDark={isDark} />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SKILLS.map((skill, i) => (
            <SkillCard key={skill.category} skill={skill} isDark={isDark} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
